var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.14 12.2047C21.14 11.5665 21.0827 10.9529 20.9764 10.3638H12.5V13.8451H17.3436C17.135 14.9701 16.5009 15.9233 15.5477 16.5615V18.8197H18.4564C20.1582 17.2529 21.14 14.9456 21.14 12.2047Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4998 21C14.9298 21 16.967 20.1941 18.4561 18.8195L15.5475 16.5613C14.7416 17.1013 13.7107 17.4204 12.4998 17.4204C10.1557 17.4204 8.17158 15.8372 7.46385 13.71H4.45703V16.0418C5.93794 18.9831 8.98158 21 12.4998 21Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46409 13.7101C7.28409 13.1701 7.18182 12.5933 7.18182 12.0001C7.18182 11.4069 7.28409 10.8301 7.46409 10.2901V7.95825H4.45727C3.84773 9.17325 3.5 10.5478 3.5 12.0001C3.5 13.4523 3.84773 14.8269 4.45727 16.0419L7.46409 13.7101Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4998 6.57955C13.8211 6.57955 15.0075 7.03364 15.9402 7.92545L18.5216 5.34409C16.9629 3.89182 14.9257 3 12.4998 3C8.98158 3 5.93794 5.01682 4.45703 7.95818L7.46385 10.29C8.17158 8.16273 10.1557 6.57955 12.4998 6.57955Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2006b082efb555f09fe20b3fe2c749c9.svg";
export { ForwardRef as ReactComponent };